// extracted by extract-css-chunks-webpack-plugin
module.exports = {"BasicInput":"BasicInput_3zAp4_v16-5-1","__Invalid":"__Invalid_36oyk_v16-5-1"};